import React from 'react'
import { connect } from 'react-redux'
import injectSheet from 'react-jss'
import style from './style'
import { destroyCameraAction } from 'actions/cameraActions'
import { destroyMultiImagerAction } from 'actions/multiImagerActions'
import getCurrentCamera from 'helpers/cameras/getCurrentCamera'

const mapStateToProps = ({ cameras, currentEntity }) => {
  const currentCamera = getCurrentCamera(cameras)
  return {
    currentCamera,
    cameraSelected: currentCamera && currentEntity.type === 'camera' && currentEntity.id === currentCamera.id,
    multiImager: currentCamera && cameras.find(c => c.id === currentCamera.imagerId)
  }
}

class DeleteCamera extends React.Component {
  componentDidMount = _ => {
    if (!this.props.cameraSelected || !this.props.currentCamera) return this.props.close()
  }

  acceptButtonClicked = _ => {
    const { currentCamera: { id, isMultiImager, imagerId }, close, destroyCameraAction, destroyMultiImagerAction } = this.props

    close()
    if (isMultiImager) destroyMultiImagerAction(id)
    else if (imagerId) destroyMultiImagerAction(imagerId)
    else destroyCameraAction(id)
  }

  render() {
    const { props: { cameraSelected, currentCamera, close, multiImager, classes }, acceptButtonClicked } = this

    if (!cameraSelected || !currentCamera) return null

    const { id, name, isMultiImager, imagerId } = currentCamera

    return (
      <div>
        { imagerId
          ? <p>Delete {multiImager.name} and all imagers?</p>
          : <p>Delete {name + (isMultiImager ? ' and all imagers' : '')}?</p>
        }
        <div className={classes.buttonContainer}>
          <div
            className={classes.confirmButton}
            onClick={acceptButtonClicked}
          >
            Yes
          </div>
          <div
            className={classes.rejectButton}
            onClick={close}
          >
            No
          </div>
        </div>
      </div>
    )
  }
}

export const DeleteCameraConfig = { title: '' }
export default connect(mapStateToProps, { destroyCameraAction, destroyMultiImagerAction })(injectSheet(style)(DeleteCamera))



// WEBPACK FOOTER //
// ./src/components/DeleteCamera/index.js